import React from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Avatar from '@mui/material/Avatar';
import { IconButton, TableCell, TableRow } from "@mui/material";
import { processUrl } from 'common/Service';

interface CartItemProps {
    item: {
        _id: string;
        title: string;
        unitLabel: string;
        sellingPrice: number;
        imageUrl: string
    };
    quantity: number;
    onQuantityChange: (_id: string, quantity: number) => void;
    onRemoveFromCart: (i_d: string) => void;
}

const CartItem: React.FC<CartItemProps> = ({ item, quantity, onQuantityChange, onRemoveFromCart }) => {
    return (
        <TableRow key={item._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row">
                <Avatar sx={{ width: 56, height: 56 }} style={{ borderRadius: 0 }}
                    alt={item.title} src={processUrl(item.imageUrl)} />
            </TableCell>

            <TableCell component="th" scope="row">
                {item.title}
            </TableCell>
            <TableCell >{item?.unitLabel?.toUpperCase()}</TableCell>
            <TableCell >&#8377;{item.sellingPrice}</TableCell>
            <TableCell >
                <div className="quantity-control">
                    <IconButton
                        size='small'
                        onClick={() => onQuantityChange(item._id, quantity - 1)}
                        style={{ borderRadius: "5px", color: "white", backgroundColor: "#0ea04e", }}
                    >
                        <RemoveIcon fontSize='small' />
                    </IconButton>

                    <span className="quantity">{quantity}</span>
                    <IconButton
                        size='small'
                        onClick={() => onQuantityChange(item._id, quantity + 1)}
                        style={{ borderRadius: "5px", color: "white", backgroundColor: "#0ea04e" }}
                    >
                        <AddIcon fontSize='small' />
                    </IconButton>

                </div>
            </TableCell>
        </TableRow>
    );
};

export default CartItem;
